import { Cached } from "@mui/icons-material";
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, OutlinedInput, styled, TextField, Typography } from "@mui/material"
import { DissipationType, DrainLocation, ElectricalPhase, GasLocation, GasType, Hertz, PlugType, VentType, VoltageType, Volts } from "../../../../../common/const";
import { showNotification } from "../../../../../common/Notification/ToastifyNotification";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 10
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 10
}));

const MEP = ({
  itemData,
  items,
  setItems,
}) => {
  return (
    <>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>MEP Specifications</Typography>
      <Typography variant="body2" sx={{ fontSize: 12 }}>Specific equipment requirements related to mechanical, electrical and plumbing</Typography>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>Mechanical</Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Cached />}
            onClick={() => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  mechanical_data: {
                    heatDissipation: itemData?.product?.mechanical_data?.heatDissipation,
                    dissipationType: itemData?.product?.mechanical_data?.dissipationType,
                    vent: itemData?.product?.mechanical_data?.vent,
                    ventType: itemData?.product?.mechanical_data?.ventType,
                    mechanicalRemarks: itemData?.product?.mechanical_data?.mechanicalRemarks
                  }
                }
              }));
            }}
          >
            Reset Section
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2} mt={0.5}>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Heat Dissipation BTU/Hr</InputLabel>
            <OutlinedInput
              label="Heat Dissipation BTU/Hr"
              id="standard-adornment-password"
              type='number'
              value={items?.product_data?.mechanical_data?.heatDissipation}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    mechanical_data: {
                      ...prevData.product_data.mechanical_data,
                      heatDissipation: e.target?.value || null
                    }
                  }
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
          {items?.product_data?.mechanical_data?.heatDissipation !== itemData?.product?.mechanical_data?.heatDissipation && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{`${itemData?.product?.mechanical_data?.heatDissipation} BTH/Hr` || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={DissipationType.find((c) => c.value === items?.product_data?.mechanical_data?.dissipationType) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={DissipationType}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  mechanical_data: {
                    ...prevData.product_data.mechanical_data,
                    dissipationType: newValue?.value || null
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Dissipation Type" name="Dissipation Type" variant="outlined" />}
          />
          {items?.product_data?.mechanical_data?.dissipationType !== itemData?.product?.mechanical_data?.dissipationType && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{DissipationType.find((c) => c.value === itemData?.product_data?.mechanical_data?.dissipationType)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.mechanical_data?.vent}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        mechanical_data: {
                          ...prevData.product_data.mechanical_data,
                          vent: e.target.checked,
                          ventType: null
                        }
                      }
                    }));
                  }}
                />}
              label="Vent Needed"
            />
          </FormGroup>
          {items?.product_data?.mechanical_data?.vent !== itemData?.product?.mechanical_data?.vent && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product_data?.mechanical_data?.vent ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={VentType.find((c) => c.value === items?.product_data?.mechanical_data?.ventType) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={VentType}
            getOptionLabel={(option) => option?.name}
            disabled={!items?.product_data?.mechanical_data?.vent}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  mechanical_data: {
                    ...prevData.product_data.mechanical_data,
                    ventType: newValue?.value || null
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Vent Type" name="Vent Type" variant="outlined" />}
          />
          {items?.product_data?.mechanical_data?.ventType !== itemData?.product?.mechanical_data?.ventType && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{VentType.find((c) => c.value === itemData?.product?.mechanical_data?.ventType)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Mechanical Remarks</InputLabel>
            <OutlinedInput
              label="Mechanical Remarks"
              id="standard-adornment-password"
              type='text'
              multiline
              minRows={5}
              value={items?.product_data?.mechanical_data?.mechanicalRemarks}
              onChange={(e) => {
                if (e.target.value?.length > 300) {
                  showNotification('The Remarks should be maximum 300 characters long', 'error');
                } else {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      mechanical_data: {
                        ...prevData.product_data.mechanical_data,
                        mechanicalRemarks: e.target.value || null,
                      }
                    }
                  }));
                }
              }}
            />
            {items?.product_data?.mechanical_data?.mechanicalRemarks !== itemData?.product?.mechanical_data?.mechanicalRemarks && (
              <Box display="flex" alignItems="center">
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.mechanical_data?.mechanicalRemarks || '--'}</DefaultTypo1>
              </Box>
            )}
          </FormControl>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>Electrical</Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Cached />}
            onClick={() => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  electrical_data: {
                    voltageType: itemData?.product?.electrical_data?.voltageType,
                    volts: itemData?.product?.electrical_data?.volts,
                    amps: itemData?.product?.electrical_data?.amps,
                    hertz: itemData?.product?.electrical_data?.hertz,
                    watts: itemData?.product?.electrical_data?.watts,
                    kva: itemData?.product?.electrical_data?.kva,
                    electricalPhase: itemData?.product?.electrical_data?.electricalPhase,
                    plugtype: itemData?.product?.electrical_data?.plugtype,
                    plugdetail: itemData?.product?.electrical_data?.plugdetail,
                    dedicatedCircuit: itemData?.product?.electrical_data?.dedicatedCircuit,
                    emergencyPower: itemData?.product?.electrical_data?.emergencyPower,
                    remoteTrans: itemData?.product?.electrical_data?.remoteTrans,
                    remoteSwitch: itemData?.product?.electrical_data?.remoteSwitch,
                    electricalRemarks: itemData?.product?.electrical_data?.electricalRemarks
                  }
                }
              }));
            }}
          >
            Reset Section
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2} mt={0.5}>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={VoltageType.find((c) => c.value === items?.product_data?.electrical_data?.voltageType) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={VoltageType}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  electrical_data: {
                    ...prevData.product_data.electrical_data,
                    voltageType: newValue?.value || null,
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Voltage Type" name="Voltage Type" variant="outlined" />}
          />
          {(items?.product_data?.electrical_data?.voltageType !== itemData?.product?.electrical_data?.voltageType) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{VoltageType.find((a) => a.value === itemData?.product?.electrical_data?.voltageType)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={Volts.find((c) => c.value === items?.product_data?.electrical_data?.volts) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={Volts}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  electrical_data: {
                    ...prevData.product_data.electrical_data,
                    volts: newValue?.value || null,
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Volts" name="Volts" variant="outlined" />}
          />
          {(items?.product_data?.electrical_data?.volts !== itemData?.product?.electrical_data?.volts) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.volts ? `${itemData?.product?.electrical_data?.volts} V` : '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Amps</InputLabel>
            <OutlinedInput
              label="Amps"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.electrical_data?.amps}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    electrical_data: {
                      ...prevData.product_data.electrical_data,
                      amps: e.target?.value || null,
                    }
                  }
                }));
              }}
            />
          </FormControl>
          {(items?.product_data?.electrical_data?.amps !== itemData?.product?.electrical_data?.amps) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.amps ? `${itemData?.product?.electrical_data?.amps} A` : '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={Hertz.find((c) => c.value === items?.product_data?.electrical_data?.hertz) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={Hertz}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  electrical_data: {
                    ...prevData.product_data.electrical_data,
                    hertz: newValue?.value || null,
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Hertz" name="Hertz" variant="outlined" />}
          />
          {(items?.product_data?.electrical_data?.hertz !== itemData?.product?.electrical_data?.hertz) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.hertz ? `${itemData?.product?.electrical_data?.hertz} Hz` : '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Watts</InputLabel>
            <OutlinedInput
              label="Watts"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.electrical_data?.watts}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    electrical_data: {
                      ...prevData.product_data.electrical_data,
                      watts: e.target?.value || null,
                    }
                  }
                }));
              }}
            />
          </FormControl>
          {(items?.product_data?.electrical_data?.watts !== itemData?.product?.electrical_data?.watts) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.watts ? `${itemData?.product?.electrical_data?.watts} W` : '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">kVA</InputLabel>
            <OutlinedInput
              label="kVA"
              id="standard-adornment-password"
              type='number'
              value={items?.product_data?.electrical_data?.kva}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    electrical_data: {
                      ...prevData.product_data.electrical_data,
                      kva: e.target?.value || null,
                    }
                  }
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
          {(items?.product_data?.electrical_data?.kva !== itemData?.product?.electrical_data?.kva) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.kva ? `${itemData?.product?.electrical_data?.kva} kVA` : '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={ElectricalPhase.find((c) => c.value === items?.product_data?.electrical_data?.electricalPhase) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={ElectricalPhase}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  electrical_data: {
                    ...prevData.product_data.electrical_data,
                    electricalPhase: newValue?.value || null
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Phase" name="Phase" variant="outlined" />}
          />
          {(items?.product_data?.electrical_data?.electricalPhase !== itemData?.product?.electrical_data?.electricalPhase) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{ElectricalPhase.find((a) => a.value === itemData?.product?.electrical_data?.electricalPhase)?.name || '--'}</DefaultTypo1>
            </Box>)}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={PlugType.find((c) => c.value === items?.product_data?.electrical_data?.plugtype) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={PlugType}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  electrical_data: {
                    ...prevData.product_data.electrical_data,
                    plugtype: newValue?.value || null
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Plug Type" name="Plug Type" variant="outlined" />}
          />
          {(items?.product_data?.electrical_data?.plugtype !== itemData?.product?.electrical_data?.plugtype) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{PlugType.find((a) => a.value === itemData?.product?.electrical_data?.plugtype)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Plug Details</InputLabel>
            <OutlinedInput
              label="Plug Details"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.electrical_data?.plugdetail}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    electrical_data: {
                      ...prevData.product_data.electrical_data,
                      plugdetail: e.target?.value || null
                    }
                  }
                }));
              }}
            />
          </FormControl>
          {(items?.product_data?.electrical_data?.plugdetail !== itemData?.product?.electrical_data?.plugdetail) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.plugdetail || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.electrical_data?.dedicatedCircuit}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        electrical_data: {
                          ...prevData.product_data.electrical_data,
                          dedicatedCircuit: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Dedicated Circuit"
            />
          </FormGroup>
          {(items?.product_data?.electrical_data?.dedicatedCircuit !== itemData?.product?.electrical_data?.dedicatedCircuit) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.dedicatedCircuit ? 'Manufacturer Recommended' : 'No'}</DefaultTypo1>
            </Box>
          )}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.electrical_data?.emergencyPower}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        electrical_data: {
                          ...prevData.product_data.electrical_data,
                          emergencyPower: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Emergency Power"
            />
          </FormGroup>
          {(items?.product_data?.electrical_data?.emergencyPower !== itemData?.product?.electrical_data?.emergencyPower) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.emergencyPower ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.electrical_data?.remoteTrans}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        electrical_data: {
                          ...prevData.product_data.electrical_data,
                          remoteTrans: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Remote Transformer"
            />
            {(items?.product_data?.electrical_data?.remoteTrans !== itemData?.product?.electrical_data?.remoteTrans) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.remoteTrans ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.electrical_data?.remoteSwitch}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        electrical_data: {
                          ...prevData.product_data.electrical_data,
                          remoteSwitch: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Remote Switch/Controller"
            />
          </FormGroup>
          {(items?.product_data?.electrical_data?.remoteSwitch !== itemData?.product?.electrical_data?.remoteSwitch) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.remoteSwitch ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Electrical Remarks</InputLabel>
            <OutlinedInput
              label="Electrical Remarks"
              id="standard-adornment-password"
              type='text'
              multiline
              minRows={5}
              value={items?.product_data?.electrical_data?.electricalRemarks}
              onChange={(e) => {
                if (e.target.value?.length > 300) {
                  showNotification('The Remarks should be maximum 300 characters long', 'error');
                } else {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      electrical_data: {
                        ...prevData.product_data.electrical_data,
                        electricalRemarks: e.target.value
                      }
                    }
                  }));
                }
              }}
            />
          </FormControl>
          {(items?.product_data?.electrical_data?.electricalRemarks !== itemData?.product?.electrical_data?.electricalRemarks) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.electricalRemarks || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>Plumbing</Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Cached />}
            onClick={() => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  plumbing_data: {
                    plumbingRemarks: itemData?.product?.plumbing_data?.plumbingRemarks,
                    hotWater: itemData?.product?.plumbing_data?.hotWater,
                    coldWater: itemData?.product?.plumbing_data?.coldWater,
                    treatedWater: itemData?.product?.plumbing_data?.treatedWater,
                    drain: itemData?.product?.plumbing_data?.drain,
                    drainLocation: itemData?.product?.plumbing_data?.drainLocation,
                    steam: itemData?.product?.plumbing_data?.steam,
                    vaccumMedical: itemData?.product?.plumbing_data?.vaccumMedical,
                    vaccumDental: itemData?.product?.plumbing_data?.vaccumDental,
                    medicalGas: itemData?.product?.plumbing_data?.medicalGas,
                    gasType: itemData?.product?.plumbing_data?.gasType,
                    gasLocation: itemData?.product?.plumbing_data?.gasLocation,
                  }
                }
              }));
            }}
          >
            Reset Section
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2} mt={0.5}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.hotWater}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          hotWater: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Hot Water"
            />
            {(items?.product_data?.plumbing_data?.hotWater !== itemData?.product?.plumbing_data?.hotWater) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.hotWater ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.coldWater}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          coldWater: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Cold Water"
            />
            {(items?.product_data?.plumbing_data?.coldWater !== itemData?.product?.plumbing_data?.coldWater) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.coldWater ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.treatedWater}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          treatedWater: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Treated Water"
            />
            {(items?.product_data?.plumbing_data?.treatedWater !== itemData?.product?.plumbing_data?.treatedWater) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.treatedWater ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.drain}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          drain: e.target.checked,
                          drainLocation: null
                        }
                      }
                    }));
                  }}
                />}
              label="Drain"
            />
            {(items?.product_data?.plumbing_data?.drain !== itemData?.product?.plumbing_data?.drain) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.drain ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.steam}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          steam: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Steam"
            />
            {(items?.product_data?.plumbing_data?.steam !== itemData?.product?.plumbing_data?.steam) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.steam ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.vaccumMedical}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          vaccumMedical: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Vaccum - Medical"
            />
            {(items?.product_data?.plumbing_data?.vaccumMedical !== itemData?.product?.plumbing_data?.vaccumMedical) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.vaccumMedical ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.vaccumDental}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          vaccumDental: e.target.checked
                        }
                      }
                    }));
                  }}
                />}
              label="Vaccum - Dental"
            />
            {(items?.product_data?.plumbing_data?.vaccumDental !== itemData?.product?.plumbing_data?.vaccumDental) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.vaccumDental ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.plumbing_data?.medicalGas}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        plumbing_data: {
                          ...prevData.product_data.plumbing_data,
                          medicalGas: e.target.checked,
                          gasType: [],
                          gasLocation: null
                        }
                      }
                    }));
                  }}
                />}
              label="Medical Gas"
            />
            {(items?.product_data?.plumbing_data?.medicalGas !== itemData?.product?.plumbing_data?.medicalGas) && (
              <Box display="flex" alignItems="center" gap={1}>
                <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.medicalGas ? 'Yes' : 'No'}</DefaultTypo1>
              </Box>
            )}
          </FormGroup>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            value={DrainLocation.find((c) => c.value === items?.product_data?.plumbing_data?.drainLocation) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            disabled={!items?.product_data?.plumbing_data?.drain}
            options={DrainLocation}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  plumbing_data: {
                    ...prevData.product_data.plumbing_data,
                    drainLocation: newValue?.value || null
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Drain Location" name="Drain Location" variant="outlined" />}
          />
          {(items?.product_data?.plumbing_data?.drainLocation !== itemData?.product?.plumbing_data?.drainLocation) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{DrainLocation.find((a) => a.value === itemData?.product?.plumbing_data?.drainLocation)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            value={GasType.filter((c) => items?.product_data?.plumbing_data?.gasType?.includes(c.value)) || []}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={GasType}
            multiple
            disabled={!items?.product_data?.plumbing_data?.medicalGas}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  plumbing_data: {
                    ...prevData.product_data.plumbing_data,
                    gasType: newValue?.map((a) => a.value) || []
                  }
                }
              }));
            }}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option?.name}
                </li>
              );
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Gas Type" name="Gas Type" variant="outlined" />}
          />
          {(JSON.stringify(items?.product_data?.plumbing_data?.gasType) !== JSON.stringify(itemData?.product?.plumbing_data?.gasType)) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.gasType?.length > 0
                ? GasType.filter((a) => itemData?.product?.plumbing_data?.gasType?.includes(a.value))
                  .map((a, index) => (
                    <span key={index}>
                      {a.name}
                      <br />
                    </span>
                  ))
                : '--'}
              </DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Plumbing Remarks</InputLabel>
            <OutlinedInput
              label="Plumbing Remarks"
              id="standard-adornment-password"
              type='text'
              multiline
              minRows={5}
              value={items?.product_data?.plumbing_data?.plumbingRemarks}
              onChange={(e) => {
                if (e.target.value?.length > 300) {
                  showNotification('The Remarks should be maximum 300 characters long', 'error');
                } else {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      plumbing_data: {
                        ...prevData.product_data.plumbing_data,
                        plumbingRemarks: e.target.value || null
                      }
                    }
                  }));
                }
              }}
            />
          </FormControl>
          {(items.product_data?.plumbing_data?.plumbingRemarks !== itemData?.product?.plumbing_data?.plumbingRemarks) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.plumbingRemarks || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            value={GasLocation.find((c) => c.value === items?.product_data?.plumbing_data?.gasLocation) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={GasLocation}
            disabled={!items?.product_data?.plumbing_data?.medicalGas}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  plumbing_data: {
                    ...prevData.product_data.plumbing_data,
                    gasLocation: newValue?.value || null
                  }
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Gas Location" name="Gas Location" variant="outlined" />}
          />
          {(items?.product_data?.plumbing_data?.gasLocation !== itemData?.product?.plumbing_data?.gasLocation) && (
            <Box display="flex" alignItems="center" gap={1}>
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{GasLocation.find((a) => a.value === itemData?.product?.plumbing_data?.gasLocation)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default MEP;